import {useState} from 'react'
import {getInitials, getWelcomeMsg} from '../../../helper/profileHelper'
import {useSelector} from 'react-redux'
import {
  StyledDiv,
  StyledLogoutIcon,
  StyledMenu,
  StyledProfileCircleTypography,
  StyledProfileIcon,
  StyledSpan,
  StyledTitleContainer
} from './ProfileCircleStyles'
import PropTypes from 'prop-types'
import {MenuItem} from '@mui/material'
import {useMsal} from '@azure/msal-react'
import {useApolloClient} from '@apollo/client'
import {openInNewTab} from '../../Auth/SignIn'
import CustomDialog from '../CustomDialog'
import {StyledActionBox} from '../Styles'
import {StyledActionResetButton} from '../../Campaigns/AskGivePrism/Styles'
import TermsOfUse from '../../TermsOfUse/TermsOfUseIndex'
import LegalNotice from '../../LegalNotice/LegalNoticeIndex'

const privacyStatementUrl = 'https://www2.deloitte.com/us/en/footerlinks1/deloitte-commercial-asset-privacy-notice.html'

const ProfileCircle = ({placement, welcomeMessage = false}) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const name = useSelector((state) => state.userProfile.name)
  const isProfileOpened = Boolean(anchorEl)
  const id = isProfileOpened ? 'profile-popover' : undefined
  const {instance} = useMsal()
  const client = useApolloClient()
  const [heading, setHeading] = useState('')
  const [dialog, setDialog] = useState(false)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = async () => {
    await client.clearStore()
    await instance.logoutRedirect()
  }

  const handleModalClose = () => {
    setDialog(false)
    setHeading('')
  }

  const handleChange = (heading) => {
    setHeading(heading)
    setDialog(true)
  }

  return (
    <>
      <StyledDiv>
        <StyledProfileIcon aria-describedby={id} onClick={handleClick} sx={{float: placement}}>
          {getInitials(name)}
        </StyledProfileIcon>
        {welcomeMessage && <StyledProfileCircleTypography>{getWelcomeMsg(name)}</StyledProfileCircleTypography>}
      </StyledDiv>
      <StyledMenu
        id="basic-menu"
        anchorEl={anchorEl}
        open={isProfileOpened}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        <MenuItem
          onClick={() => openInNewTab('https://cookienotice.deloitte.com')}
          target="_href"
          rel="noopener noreferrer"
        >
          <StyledSpan>Cookies</StyledSpan>
        </MenuItem>
        <MenuItem onClick={() => globalThis.OneTrust?.ToggleInfoDisplay()}>
          <StyledSpan>Cookie Settings</StyledSpan>
        </MenuItem>
        <MenuItem onClick={() => openInNewTab(privacyStatementUrl)} target="_href">
          <StyledSpan>Privacy Statement</StyledSpan>
        </MenuItem>
        <MenuItem onClick={() => handleChange('Legal Notice')}>
          <StyledSpan>Legal Notice</StyledSpan>
        </MenuItem>
        <MenuItem onClick={() => handleChange('Terms of Use')}>
          <StyledSpan>Terms of Use</StyledSpan>
        </MenuItem>
        <MenuItem onClick={handleLogout}>
          <StyledLogoutIcon />
          <StyledSpan>Logout</StyledSpan>
        </MenuItem>
      </StyledMenu>
      <CustomDialog
        open={dialog}
        showDivider={true}
        maxWidth="md"
        title={<StyledTitleContainer>{heading}</StyledTitleContainer>}
        handleClose={handleModalClose}
        content={
          heading === 'Terms of Use' ? (
            <TermsOfUse open={dialog} handleClose={handleModalClose} />
          ) : (
            <LegalNotice open={dialog} handleClose={handleModalClose} />
          )
        }
        actions={
          <StyledActionBox>
            <StyledActionResetButton onClick={handleModalClose}>Close</StyledActionResetButton>
          </StyledActionBox>
        }
      />
    </>
  )
}

ProfileCircle.propTypes = {
  placement: PropTypes.string,
  welcomeMessage: PropTypes.bool
}

export default ProfileCircle
